import { createMultiStyleConfigHelpers, ComponentStyleConfig } from '@chakra-ui/react';
import { radioAnatomy } from '@chakra-ui/anatomy';
import { transparentize } from '@chakra-ui/theme-tools';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(radioAnatomy.keys);

const baseStyle = definePartsStyle({
  control: {
    alignSelf: 'start',

    _light: {
      _checked: {
        _focusVisible: {
          boxShadow: 'outlineInverse',
        },
      },
    },
  },
});

const sizes = {
  sm: {
    container: {
      minHeight: 8,
      py: 1.5,
    },
    control: {
      mt: 0.5,
      height: 4,
      width: 4,
    },
    icon: {
      fontSize: '2xs',
    },
    label: {
      lineHeight: 5,
    },
  },
  md: {
    container: {
      minHeight: 10,
      py: 2,
    },
    control: {
      mt: 1,
      height: 4,
      width: 4,
    },
    icon: {
      fontSize: '2xs',
    },
  },
  lg: {
    container: {
      minHeight: 12,
      py: 2.5,
    },
    control: {
      mt: 1,
      height: 5,
      width: 5,
    },
    icon: {
      fontSize: 'xs',
    },
  },
};

const outline = definePartsStyle(props => {
  const { colorScheme, theme } = props;

  return {
    container: {
      bgColor: 'chakra-body-bg',
      borderRadius: 'lg',
      display: 'flex',
      px: 4,
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineOffset: '-2px',
      outlineColor: 'gray.200',

      _dark: {
        outlineColor: 'whiteAlpha.300',
      },

      _checked: {
        bgColor: `${colorScheme}.100`,
        outlineColor: `${colorScheme}.300`,

        _dark: {
          bgColor: 'chakra-body-bg',
          outlineColor: `${colorScheme}.300`,
        },
      },

      _disabled: {
        bgColor: 'initial',
        outlineColor: 'gray.100',

        _dark: {
          bgColor: 'initial',
          outlineColor: 'whiteAlpha.100',
        },
      },
      _invalid: {
        outlineColor: 'red.500',
        _dark: {
          outlineColor: transparentize(`red.300`, 0.5)(theme),
        },
      },
    },
  };
});

const ghost = definePartsStyle(props => {
  const { colorScheme, theme } = props;

  return {
    container: {
      borderRadius: 'lg',
      display: 'flex',
      px: 4,

      _checked: {
        bgColor: `${colorScheme}.100`,

        _dark: {
          bgColor: 'blackAlpha.100',
        },
      },

      _disabled: {
        bgColor: 'initial',

        _dark: {
          bgColor: 'initial',
        },
      },
      _invalid: {
        bgColor: transparentize(`red.100`, 0.5)(theme),
        _dark: {
          bgColor: transparentize(`red.300`, 0.1)(theme),
        },
      },
    },
  };
});

export const radioTheme: ComponentStyleConfig = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants: {
    outline,
    ghost,
  },
});
